export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.0.8';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /~/@sentry/browser/esm/version.js
// module id = f06t
// module chunks = 0